import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/App.css";
import Header from "./components/home/Header";
import Services from "./components/home/Services";
import About from "./components/home/About";
import Emergency from "./components/home/Emergency";
import Team from "./components/home/Team";
import Gallery from "./components/home/Gallery";
import Testimonials from "./components/home/Testimonials";
import HealthCallToAction from "./components/home/HealthCallToAction";
import Login from "./components/home/Login";
import Register from "./components/home/Register";
import BlogLeftSidebar from "./components/home/BlogLeftSidebar";
import ContactUs from "./components/home/ContactUs";
import Advertisement from "./pages/Advertisement";
import Pages from "./pages/Pages";
import Posts from "./pages/Posts";
import Subscription from "./pages/Subscription";
import SubscriptionHistory from "./pages/SubscriptionHistory";
import Comment from "./pages/Comment";
import User from "./pages/User";
import Category from "./pages/Category";
import Dashboard from "./pages/Dashboard";
import Results from "./components/home/Result";
import CategoryBox from "./components/home/CategoryBox";
import Dropdown from "./pages/Dropdown";
import EmployeeLogin from "./pages/EmployeeLogin";
import Logout from "./pages/Logout";
import UserFooter from "./components/home/UserFooter";
import Community from "./components/home/Community";
import UsersPage from "./components/home/UsersPage";
import Attachment from "./components/home/Attachment";
import Sliders from "./pages/Sliders";
import Slider from "./components/admin/SliderForm";
import CategoryBox2 from "./components/home/CategoryBox2";
import UserPage2 from "./components/home/UserPage2";
import Attachment2 from "./components/home/Attachment2";
import Slide from "./components/home/Slide";
import HomeAdvertisementCategoryCarousel from "./components/home/HomeAdvertisementCategoryCarousel";
import Search from "./components/home/Search";
import Banner from "./components/home/Banner";
import Banner2 from "./components/home/Banner2";

function Home() {
  return (
    <>
      <Header />
      <Slide />
      <Banner />
      <HomeAdvertisementCategoryCarousel />
      <Search />
      <Banner2 />
      <Services />
      <About />
      {/* <Community /> */}
      <Emergency />
      <Team />
      <Gallery />
      <Testimonials />
      <HealthCallToAction />
      {/* <Footer />
       */}
      <UserFooter />
    </>
  );
}

function App() {
  const getAdmin = () => {
    const user = JSON.parse(localStorage.getItem("VVRHCS"));
    const token = user?.token;
    const role = user?.role;
    let flag = token !== null && token !== undefined && role === "Admin";
    return flag;
  };
  const [isAdmin, setIsAdmin] = useState(getAdmin());

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/userAttachment" element={<Attachment />} />
        <Route path="/userAttachment2" element={<Attachment2 />} />
        <Route
          path="/admin/login"
          element={<EmployeeLogin setIsAdmin={setIsAdmin} />}
        />
        <Route path="/register" element={<Register />} />
        <Route path="/blogLeftSidebar" element={<BlogLeftSidebar />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/results" element={<Results />} />
        <Route path="/pages/:id" element={<UsersPage />} />
        <Route path="/page2/:id" element={<UserPage2 />} />

        <Route
          path="/admin/advertisement"
          element={isAdmin ? <Advertisement /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/sliders"
          element={isAdmin ? <Sliders /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/slideForm"
          element={isAdmin ? <Slider /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/pages"
          element={isAdmin ? <Pages /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/posts"
          element={isAdmin ? <Posts /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/subscripers"
          element={isAdmin ? <Subscription /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/user"
          element={isAdmin ? <User /> : <Navigate to="/admin/login" />}
        />
        {/* <Route path="/category/:id" element={<CategoryBox />} /> */}
        <Route path="/category2" element={<CategoryBox2 />} />
        <Route path="/category" element={<CategoryBox />} />
        <Route
          path="/admin/subscripersHistory/:id"
          element={
            isAdmin ? <SubscriptionHistory /> : <Navigate to="/admin/login" />
          }
        />
        <Route
          path="/admin/comments"
          element={isAdmin ? <Comment /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/dropdown"
          element={isAdmin ? <Dropdown /> : <Navigate to="/admin/login" />}
        />
        <Route
          path="/admin/category"
          element={isAdmin ? <Category /> : <Navigate to="/admin/login" />}
        />
        {/* <Route path="/admin" element={<Dashboard />} /> */}
        <Route
          path="/admin"
          element={isAdmin ? <Dashboard /> : <Navigate to="/admin/login" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
